<template>
  <div class="normal-user-label">
    <div class="vip-list" v-if="vipList.length">
      <img
        v-for="(item, index) in vipList"
        :key="index"
        :src="item.image"
        :alt="item.name"
        @click="toVipPage(item)"
      />
    </div>
    <div class="level-and-tags">
      <div class="tag-list-wrap" v-if="parsedLevel || tagList.length">
        <ul class="tag-list" :class="{ m: tagList.length > 3 }">
          <li
            class="parsed-level tag"
            v-if="parsedLevel"
            @click="toLevelExplain"
          >
            <img v-if="parsedLevel.icon" :src="parsedLevel.icon" />
            {{ `lv.${parsedLevel.level_val_origin} ${parsedLevel.level_name}` }}
          </li>
          <template v-if="tagList.length">
            <li
              class="tag not-zx-tag"
              v-for="tag in tagList.slice(0, 3)"
              :key="tag.name"
              @click="onTagClick"
            >
              <p>{{ tag.name }}</p>
            </li>
          </template>
        </ul>
        <van-icon
          v-if="tagList.length > 3"
          name="arrow"
          class="icon-arrow"
          @click="onTagClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Icon as VanIcon } from 'vant'
export default {
  components: {
    VanIcon
  },
  computed: {
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    vipList() {
      const { vip } = this.basicInfo
      return Array.isArray(vip) ? vip : []
    },
    parsedLevel() {
      return this.$store.getters['homepage/parsedLevel']
    },
    tagList() {
      const { identities } = this.basicInfo
      return Array.isArray(identities) ? identities : []
    }
  },
  methods: {
    toLevelExplain() {
      this.$trackEvent('newprofilepages_levellabel', {})
      this.routerPushWithoutNav(`/growthCenter/levelExplain`)
    },
    onTagClick() {
      this.$trackEvent('newprofilepages_certificationtags', {})
      this.routerToStaic({
        path: '/identify/index',
        query: {
          id: this.$route.params.userId,
          hideNavigationBar: 1
        }
      })
    },
    toVipPage(item) {
      const { name } = item
      const linkMap = {
        'meditating-vip': 'https://medi.onexinli.com/meditation/userCenter',
        'book-vip': 'yixinli://open_book_club_index',
        'ceping-vip': 'yixinli://open_test_home'
      }
      if (name && linkMap[name]) {
        if (linkMap[name].includes('yixinli://')) {
          if (this.$platform.isYixinliApp) {
            window.location.href = linkMap[name]
          }
          return
        } else {
          this.routerPush(linkMap[name])
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
@import '~style/platform/homepage/userinfo.scss';

.normal-user-label {
  .vip-list {
    flex-grow: 0;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-top: 30px;
    img {
      width: 72px;
      height: auto;
      object-fit: cover;
      margin-right: 10px;
    }
  }
  .tag-list-wrap {
    position: relative;
  }
  .tag-list {
    margin-top: 20px;
    &.m {
      width: calc(10rem - 100px);
    }
  }
  .parsed-level {
    background: #f0f2ff;
    padding: 0 9px !important;
    color: #6c798c;
    img {
      width: 34px;
      height: 34px;
      margin-right: 3px;
      margin-left: -5px;
    }
  }
  .icon-arrow {
    position: absolute;
    right: -20px;
    top: 20px;
    width: 56px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #6982fa;
  }
}
</style>
